import { render, staticRenderFns } from "./FaultAgreeModal.vue?vue&type=template&id=630d3883&"
import script from "./FaultAgreeModal.vue?vue&type=script&lang=js&"
export * from "./FaultAgreeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports